import { useParams } from '@tanstack/react-router'
import { toast } from 'sonner'
import { useTranslation } from '@kostbar/i18n'
import { PurchaseOrderingForm } from '../components/purchase-ordering-form'
import {
  usePurchaseOrderingConfig,
  useSavePurchaseOrderingConfig,
} from '@/features/purchase-orders/hooks/use-purchase-orders'
import { purchaseOrderErrorMessage } from '@/features/purchase-orders/lib/purchase-order-errors'
import { Skeleton } from '@/components/ui/skeleton'
import { PermissionGate } from '@/shared/components/permission-gate'
import { ACTIONS } from '@/shared/constants/actions'

/** Standorte → Standort → Bestellung (CHG-2026-10-edi-purchase-orders, task 6.2). */
export function RestaurantPurchaseOrderingPage() {
  const { t } = useTranslation('purchase-orders')
  const { id } = useParams({ strict: false })
  const restaurantId = Number(id)
  const { data, isLoading } = usePurchaseOrderingConfig(restaurantId)
  const save = useSavePurchaseOrderingConfig(restaurantId)

  return (
    <PermissionGate action={ACTIONS.RESTAURANT_MANAGE}>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold">
          {data
            ? t('config.titleFor', { name: data.restaurantName })
            : t('config.title')}
        </h1>
        {isLoading && <Skeleton className="h-64 w-full max-w-xl" />}
        {data && (
          <PurchaseOrderingForm
            // Remount with every saved version, so the fields show what the server kept.
            key={data.updatedAt ?? 'new'}
            config={data}
            saving={save.isPending}
            onSave={(body) =>
              save.mutate(body, {
                onSuccess: () => toast.success(t('toast.saved')),
                onError: (error) =>
                  toast.error(purchaseOrderErrorMessage(error, t)),
              })
            }
          />
        )}
      </div>
    </PermissionGate>
  )
}
